module.exports = __webpack_public_path__ + "static/event-mentor-mentee-vol-1-66fad16df9458aa8a95aa84ff5fe939c.jpg";